// extracted by mini-css-extract-plugin
export default {"snapshotImgRound":"WHZ9FnGscSzVIV7oc4lM"};